import { startClient } from './client';

startClient(document.getElementById('game')!, document.getElementById('ui')!);
